module.exports = function (app) {
  var html = "<div class=\"archive-summary\">\n\t\t\t\t\t<div class=\"archive-summary-title\">TX COUNT: </div>\n\t\t\t\t\t<div id=\"tx-ct\" class=\"archive-summary-value\"></div>\n\t\t\t\t\t<div class=\"archive-summary-title\">MEM USAGE: </div>\n\t\t\t\t\t<div id=\"db-size\" class=\"archive-summary-value\"></div>\n\t\t\t\t\t</div>";
  return html;
};